import { UniversalAdId } from '@lib/iab/iab-vast-model';

interface IUniversalAdId {
    idRegistry?: string;
    idValue?: string;
    _value: string;
}

const createUniversalAdId = ($universalAdId: IUniversalAdId): UniversalAdId => {
    const universalAdId = new UniversalAdId();
    if ($universalAdId.idRegistry != null) {
        universalAdId.idRegistry = $universalAdId.idRegistry;
    }
    if ($universalAdId.idValue != null) {
        universalAdId.idValue = $universalAdId.idValue;
    }
    universalAdId.creativeIdentifier = $universalAdId._value;
    return universalAdId;
};

export default createUniversalAdId;
